<template>
  <calculator-input-range
    :label="label"
    :required="required"
    :tooltip="tooltip"
    :side-tag="sideTag"
    :min="min"
    :max="max"
    :value="sanitizedValue"
    :errorShow="errorShow"
    :errorText="errorText"
    :mask="mask"
    @input="handleInput"
    :numSteps="numSteps"
    :logScale="logScale"
    :parseMaskedValue="parseMaskedValue"
  ></calculator-input-range>
</template>

<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

import calculatorInputRange from './input-range.vue'

export default {
  components: {
    calculatorInputRange,
  },
  name: 'calculatorInputRangePrice',
  data() {
    return {
      mask: createNumberMask({
        prefix: 'CHF ',
        allowDecimal: true,
        includeThousandsSeparator: true,
        allowNegative: false,
        thousandsSeparatorSymbol: "'",
      }),
    }
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: '',
    },
    sideTag: {
      type: String,
      default: '',
    },
    errorShow: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: 'This field is required',
    },
    value: {
      type: Number,
    },
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 999999999,
    },
    numSteps: {
      type: Number,
      default: 1000,
    },
    logScale: {
      type: Boolean,
      default: true,
    }
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val)
    },
    parseMaskedValue(val) {
      if (typeof val === 'number') return val

      const substr = val.slice(4)
      if (!substr) return

      const number = Number(substr.replace(/'/g, ''))
      if (!Number.isNaN(number)) {
        return number
      }
    },
  },
  computed: {
    sanitizedValue() {
      if (this.value === this.min) {
        return ' '
      }
      return this.value
    }
  }
}
</script>
